<template>
    <div>
        <div class="column-mobile-16">
            <input
                type="email"
                :value="email"
                class="form__field"
                :placeholder="placeholder"
                @input="$emit('update:email', $event.target.value)"
                :class="{
                    'is-invalid': isInvalid,
                    'is-dirty': isDirty,
                }"
            />
        </div>
        <div class="column-mobile-5 brick-mobile--left">
            <label class="form__label">
                <input
                    type="checkbox"
                    :checked="push"
                    @input="$emit('update:push', $event.target.checked)"
                />
                Push
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'notification-input-row',
    props: {
        placeholder: {
            type: String,
        },
        email: {
            type: String,
        },
        push: {
            type: Boolean,
        },
        isInvalid: {
            type: Boolean,
        },
        isDirty: {
            type: Boolean,
        },
    },
};
</script>
